<mat-dialog-content>
  <mat-hint>Number of days recall date should be within current day in order to be shown</mat-hint>
  <mat-form-field style="width:100%">
    <mat-label>Recall Date Range</mat-label>
    <input matInput type="number" [(ngModel)]="res.recallSelectionRange" />
  </mat-form-field>
  <p>
    <mat-checkbox [(ngModel)]="res.isRecallLastVisitDate">Use Last Visit Date instead of Recall Date</mat-checkbox>
  </p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button color="primary" [mat-dialog-close]="res">Save</button>
  <button mat-button color="warn" [mat-dialog-close]="null">Cancel</button>
</mat-dialog-actions>
